// Sample projects for onboarding and tutorials
const sampleProjects = [
  {
    id: 'sample-living-room-1',
    title: 'Modern Oturma Odası',
    description: 'Minimalist ve modern bir oturma odası tasarımı',
    thumbnail: '/samples/living-room-1-thumb.jpg',
    originalImage: '/samples/living-room-1-original.jpg',
    generatedImage: '/samples/living-room-1-generated.jpg',
    workflow: 'interior-redesign',
    style: 'minimalist',
    prompt: 'Modern minimalist oturma odası, açık renkli ahşap zeminler, beyaz duvarlar, gri kanepe, cam sehpa, büyük pencereler, doğal ışık, birkaç yeşil bitki, sade dekorasyon, ferah ve açık bir alan.',
    category: 'living-room'
  },
  {
    id: 'sample-kitchen-1',
    title: 'Çağdaş Mutfak',
    description: 'Açık renkli ve ferah bir mutfak tasarımı',
    thumbnail: '/samples/kitchen-1-thumb.jpg',
    originalImage: '/samples/kitchen-1-original.jpg',
    generatedImage: '/samples/kitchen-1-generated.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    prompt: 'Çağdaş mutfak tasarımı, beyaz dolaplar, mermer tezgah, ada mutfak, paslanmaz çelik cihazlar, ahşap zemin, minimalist aydınlatma, temiz çizgiler, ferah ve aydınlık alan.',
    category: 'kitchen'
  },
  {
    id: 'sample-bedroom-1',
    title: 'Huzurlu Yatak Odası',
    description: 'Sakin ve dinlendirici bir yatak odası tasarımı',
    thumbnail: '/samples/bedroom-1-thumb.jpg',
    originalImage: '/samples/bedroom-1-original.jpg',
    generatedImage: '/samples/bedroom-1-generated.jpg',
    workflow: 'interior-redesign',
    style: 'scandinavian',
    prompt: 'Huzurlu İskandinav tarzı yatak odası, büyük pencereler, doğal ışık, açık renkli ahşap zemin, beyaz duvarlar, gri yatak örtüsü, minimal mobilya, birkaç yeşil bitki, sade ve ferah.',
    category: 'bedroom'
  },
  {
    id: 'sample-bathroom-1',
    title: 'Lüks Banyo',
    description: 'Modern ve lüks bir banyo tasarımı',
    thumbnail: '/samples/bathroom-1-thumb.jpg',
    originalImage: '/samples/bathroom-1-original.jpg',
    generatedImage: '/samples/bathroom-1-generated.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    prompt: 'Lüks modern banyo, büyük duşakabin, serbest duran küvet, çift lavabo, mermer yüzeyler, gri fayanslar, ahşap detaylar, gizli aydınlatma, minimalist armatürler, spa hissi.',
    category: 'bathroom'
  },
  {
    id: 'sample-office-1',
    title: 'Ev Ofisi',
    description: 'Verimli ve şık bir ev ofisi tasarımı',
    thumbnail: '/samples/office-1-thumb.jpg',
    originalImage: '/samples/office-1-original.jpg',
    generatedImage: '/samples/office-1-generated.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    prompt: 'Modern ev ofisi, ahşap çalışma masası, ergonomik sandalye, açık raf sistemi, minimalist dekorasyon, doğal ışık, yeşil bitkiler, düzenli ve verimli çalışma alanı.',
    category: 'office'
  }
];

// Sample project templates for quick start
const projectTemplates = [
  {
    id: 'template-living-room',
    title: 'Oturma Odası Şablonu',
    description: 'Oturma odası tasarımı için başlangıç noktası',
    thumbnail: '/templates/living-room-thumb.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    prompt: 'Ferah ve modern oturma odası, rahat koltuklar, orta sehpa, halı, duvar sanatı, doğal ışık, bitkiler.',
    category: 'living-room'
  },
  {
    id: 'template-kitchen',
    title: 'Mutfak Şablonu',
    description: 'Mutfak tasarımı için başlangıç noktası',
    thumbnail: '/templates/kitchen-thumb.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    prompt: 'Modern mutfak tasarımı, ada mutfak, dolaplar, tezgah, aydınlatma, yemek alanı, modern cihazlar.',
    category: 'kitchen'
  },
  {
    id: 'template-bedroom',
    title: 'Yatak Odası Şablonu',
    description: 'Yatak odası tasarımı için başlangıç noktası',
    thumbnail: '/templates/bedroom-thumb.jpg',
    workflow: 'interior-redesign',
    style: 'scandinavian',
    prompt: 'Huzurlu yatak odası, büyük yatak, komodinler, gardırop, aydınlatma, halı, pencere, sakin renkler.',
    category: 'bedroom'
  },
  {
    id: 'template-bathroom',
    title: 'Banyo Şablonu',
    description: 'Banyo tasarımı için başlangıç noktası',
    thumbnail: '/templates/bathroom-thumb.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    prompt: 'Modern banyo tasarımı, duşakabin, küvet, lavabo, ayna, fayanslar, armatürler, aydınlatma.',
    category: 'bathroom'
  }
];

// Tutorial projects with step-by-step instructions
const tutorialProjects = [
  {
    id: 'tutorial-living-room',
    title: 'Oturma Odası Yenileme',
    description: 'Adım adım oturma odası yenileme rehberi',
    thumbnail: '/tutorials/living-room-thumb.jpg',
    originalImage: '/tutorials/living-room-original.jpg',
    generatedImage: '/tutorials/living-room-final.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    steps: [
      {
        title: 'Görsel Yükleme',
        description: 'Mevcut oturma odanızın bir fotoğrafını yükleyin.',
        image: '/tutorials/living-room-step1.jpg'
      },
      {
        title: 'Stil Seçimi',
        description: 'Yeni tasarımınız için bir stil seçin. Bu örnekte "Çağdaş" stili kullanıyoruz.',
        image: '/tutorials/living-room-step2.jpg'
      },
      {
        title: 'İstek Yazımı',
        description: 'Görmek istediğiniz değişiklikleri açıklayan bir istek yazın. Örneğin: "Modern oturma odası, açık renkli duvarlar, gri kanepe, ahşap sehpa, büyük pencereler, minimalist dekorasyon."',
        image: '/tutorials/living-room-step3.jpg'
      },
      {
        title: 'Görsel Oluşturma',
        description: 'Oluştur düğmesine tıklayın ve yapay zekanın tasarımınızı oluşturmasını bekleyin.',
        image: '/tutorials/living-room-step4.jpg'
      },
      {
        title: 'Sonuçları İnceleme',
        description: 'Oluşturulan görseli inceleyin ve gerekirse ayarlamalar yapın.',
        image: '/tutorials/living-room-step5.jpg'
      }
    ],
    category: 'tutorial'
  },
  {
    id: 'tutorial-kitchen',
    title: 'Mutfak Dönüşümü',
    description: 'Adım adım mutfak dönüşüm rehberi',
    thumbnail: '/tutorials/kitchen-thumb.jpg',
    originalImage: '/tutorials/kitchen-original.jpg',
    generatedImage: '/tutorials/kitchen-final.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    steps: [
      {
        title: 'Görsel Yükleme',
        description: 'Mevcut mutfağınızın bir fotoğrafını yükleyin.',
        image: '/tutorials/kitchen-step1.jpg'
      },
      {
        title: 'Stil Seçimi',
        description: 'Yeni tasarımınız için bir stil seçin. Bu örnekte "Çağdaş" stili kullanıyoruz.',
        image: '/tutorials/kitchen-step2.jpg'
      },
      {
        title: 'İstek Yazımı',
        description: 'Görmek istediğiniz değişiklikleri açıklayan bir istek yazın. Örneğin: "Modern mutfak, beyaz dolaplar, mermer tezgah, ada mutfak, paslanmaz çelik cihazlar."',
        image: '/tutorials/kitchen-step3.jpg'
      },
      {
        title: 'Görsel Oluşturma',
        description: 'Oluştur düğmesine tıklayın ve yapay zekanın tasarımınızı oluşturmasını bekleyin.',
        image: '/tutorials/kitchen-step4.jpg'
      },
      {
        title: 'Sonuçları İnceleme',
        description: 'Oluşturulan görseli inceleyin ve gerekirse ayarlamalar yapın.',
        image: '/tutorials/kitchen-step5.jpg'
      }
    ],
    category: 'tutorial'
  },
  {
    id: 'tutorial-masking',
    title: 'Maskeleme Tekniği',
    description: 'Görsel üzerinde belirli alanları maskeleyerek değiştirme',
    thumbnail: '/tutorials/masking-thumb.jpg',
    originalImage: '/tutorials/masking-original.jpg',
    generatedImage: '/tutorials/masking-final.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    steps: [
      {
        title: 'Görsel Yükleme',
        description: 'Düzenlemek istediğiniz görseli yükleyin.',
        image: '/tutorials/masking-step1.jpg'
      },
      {
        title: 'Maskeleme Modunu Etkinleştirme',
        description: 'Maskeleme modunu etkinleştirmek için "Maskeleme" düğmesine tıklayın.',
        image: '/tutorials/masking-step2.jpg'
      },
      {
        title: 'Alan Seçimi',
        description: 'Değiştirmek istediğiniz alanı seçmek için fare ile çizim yapın. Hassas seçim için fırça boyutunu ayarlayabilirsiniz.',
        image: '/tutorials/masking-step3.jpg'
      },
      {
        title: 'İstek Yazımı',
        description: 'Seçilen alan için özel bir istek yazın. Örneğin: "Modern ahşap zemin" veya "Mavi duvar".',
        image: '/tutorials/masking-step4.jpg'
      },
      {
        title: 'Maskelenmiş Alanı Oluşturma',
        description: 'Sadece seçilen alanı değiştirmek için "Oluştur" düğmesine tıklayın. Diğer alanlar aynı kalacaktır.',
        image: '/tutorials/masking-step5.jpg'
      },
      {
        title: 'Sonuçları İnceleme',
        description: 'Oluşturulan görseli inceleyin. Gerekirse farklı alanlar için maskeleme işlemini tekrarlayabilirsiniz.',
        image: '/tutorials/masking-step6.jpg'
      }
    ],
    category: 'tutorial'
  },
  {
    id: 'tutorial-select-replace',
    title: 'Seç ve Değiştir Modu',
    description: 'Görseldeki belirli nesneleri seçip değiştirme',
    thumbnail: '/tutorials/select-replace-thumb.jpg',
    originalImage: '/tutorials/select-replace-original.jpg',
    generatedImage: '/tutorials/select-replace-final.jpg',
    workflow: 'interior-redesign',
    style: 'contemporary',
    steps: [
      {
        title: 'Görsel Yükleme',
        description: 'Düzenlemek istediğiniz görseli yükleyin.',
        image: '/tutorials/select-replace-step1.jpg'
      },
      {
        title: 'Seç ve Değiştir Modunu Etkinleştirme',
        description: '"Seç ve Değiştir" modunu etkinleştirin.',
        image: '/tutorials/select-replace-step2.jpg'
      },
      {
        title: 'Nesne Seçimi',
        description: 'Değiştirmek istediğiniz nesneyi (örneğin bir tablo, mobilya veya aksesuar) seçin.',
        image: '/tutorials/select-replace-step3.jpg'
      },
      {
        title: 'Değişim İsteği Yazma',
        description: 'Seçilen nesne için ne istediğinizi açıklayan bir istek yazın. Örneğin: "Van Gogh tarzı yıldızlı gece tablosu" veya "Modern minimalist sehpa".',
        image: '/tutorials/select-replace-step4.jpg'
      },
      {
        title: 'Seçilen Nesneyi Değiştirme',
        description: '"Değiştir" düğmesine tıklayarak sadece seçilen nesnenin değiştirilmesini sağlayın.',
        image: '/tutorials/select-replace-step5.jpg'
      },
      {
        title: 'Birden Fazla Nesne Değiştirme',
        description: 'Aynı görselde farklı nesneleri seçip tek tek değiştirebilirsiniz. Her değişiklik sonrası sonucu inceleyip bir sonraki nesneye geçebilirsiniz.',
        image: '/tutorials/select-replace-step6.jpg'
      }
    ],
    category: 'tutorial'
  }
];

export { sampleProjects, projectTemplates, tutorialProjects };
